import {
  API_URL,
  BENEFITS_URL,
  FILE_API,
  WALLET_API,
  PARTNERS_URL,
  MISSIONS_URL,
  ADVANCED_REPORTS_URL,
  TIERS_URL,
  INVOICES_URL,
  TRAILS_URL,
} from 'src/config-global';
import { AxiosHttpClient } from 'src/http/axios.http';

export const makeApi = () => new AxiosHttpClient(API_URL);
export const makeFileApi = () => new AxiosHttpClient(FILE_API);
export const makeWalletApi = () => new AxiosHttpClient(WALLET_API);
export const makeBenefitsApi = () => new AxiosHttpClient(BENEFITS_URL);
export const makeApiPartners = () => new AxiosHttpClient(PARTNERS_URL);
export const makeMissionsApi = () => new AxiosHttpClient(MISSIONS_URL);
export const makeTiersApi = () => new AxiosHttpClient(TIERS_URL);
export const makeAdvancedReportsApi = () => new AxiosHttpClient(ADVANCED_REPORTS_URL);
export const makeInvoicesApi = () => new AxiosHttpClient(INVOICES_URL);
export const makeTrailApi = () => new AxiosHttpClient(TRAILS_URL);
export const makeTrailsApi = makeTrailApi;
